import cornerstoneTools from "cornerstone-tools";
import Formatter from "../formatter";
import cornerstone from "cornerstone-core";

const TextMarkerTool = cornerstoneTools.TextMarkerTool;
const draw = cornerstoneTools.importInternal("drawing/draw");
const setShadow = cornerstoneTools.importInternal("drawing/setShadow");
const drawTextBox = cornerstoneTools.importInternal("drawing/drawTextBox");
const getNewContext = cornerstoneTools.import("drawing/getNewContext");
const drawRect = cornerstoneTools.import("drawing/drawRect");
const pointInsideBoundingBox = cornerstoneTools.importInternal(
  "util/pointInsideBoundingBox",
);
const drawHandles = cornerstoneTools.import("drawing/drawHandles");

export default class TextMarkerResizeToolEyonix extends TextMarkerTool {
  constructor(props = {}) {
    super(props);
    this.textWidth = props.textWidth || 250;
  }


  pointNearTool(element, data, coords, interactionType) {
    const hasStartAndEndHandles = data && data.handles && data.handles.start && data.handles.end;
    const validParameters = hasStartAndEndHandles;

    if (!validParameters) {
      // logger.warn(
      //     `invalid parameters supplied to tool ${this.name}'s pointNearTool`
      // );
    }

    if (!validParameters || data.visible === false) {
      return false;
    }


    const distance = interactionType === 'mouse' ? 15 : 25;
    const startCanvas = cornerstoneTools.external.cornerstone.pixelToCanvas(
        element,
        data.handles.start
    );
    const endCanvas = cornerstoneTools.external.cornerstone.pixelToCanvas(
        element,
        data.handles.end
    );

    const rect = {
      left: Math.min(startCanvas.x, endCanvas.x),
      top: Math.min(startCanvas.y, endCanvas.y),
      width: Math.abs(startCanvas.x - endCanvas.x),
      height: Math.abs(startCanvas.y - endCanvas.y),
    };

    const distanceToPoint = cornerstoneTools.external.cornerstoneMath.rect.distanceToPoint(
        rect,
        coords
    );

    if(rect.left < coords.x && (rect.left + rect.width) > coords.x && rect.top < coords.y && (rect.top + rect.height) > coords.y) {
      return true;
    }

    return distanceToPoint < distance;

  }

  createNewMeasurement(eventData) {
    const config = this.configuration;

    if (!config.current) {
      return;
    }

    const measurementData = {
      visible: true,
      active: true,
      text: config.current,
      color: undefined,
      fontSize: undefined,
      who: undefined,
      when: undefined,
      whenStr: undefined,
      invalidated: true,
      initialRotation: eventData.viewport.rotation,
      handles: {
        end: {
          x: eventData.currentPoints.image.x,
          y: eventData.currentPoints.image.y,
          highlight: true,
          active: false,
        },
        start: {
          x: eventData.currentPoints.image.x - 75,
          y: eventData.currentPoints.image.y - 20,
          highlight: true,
          active: true,
          hasBoundingBox: true,
        },
      },
    };

    const imageRect = {
      left: 0,
      top: 0,
      width: eventData.image.width,
      height: eventData.image.height,
    };

    if (
      !cornerstoneTools.external.cornerstoneMath.point.insideRect(
        measurementData.handles.end,
        imageRect,
      )
    ) {
      return;
    }

    let currentIndex = config.markers.indexOf(config.current);

    const increment = config.ascending ? 1 : -1;

    currentIndex += increment;

    if (currentIndex >= config.markers.length) {
      currentIndex = config.loop ? 0 : -1;
    } else if (currentIndex < 0) {
      currentIndex = config.loop ? config.markers.length : -1;
    }

    config.current = config.markers[currentIndex];

    return measurementData;
  }

  renderToolData(evt) {
    const eventData = evt.detail;
    const config = this.configuration;
    const viewport = cornerstone.getViewport(eventData.element);
    // If we have no toolData for this element, return immediately as there is nothing to do
    const toolData = cornerstoneTools.getToolState(
      eventData.element,
      this.name,
    );

    if (!toolData) {
      return;
    }

    const context = getNewContext(eventData.canvasContext.canvas);
    //const hideHandlers = eventData.viewport.hideHanders || false;

    for (let i = 0; i < toolData.data.length; i++) {
      const data = toolData.data[i];

      if (data.visible === false) {
        continue;
      }

      const color = cornerstoneTools.toolColors.getColorIfActive(data);

      data.color = data.color || cornerstoneTools.toolColors.getToolColor(data);

      var bgColor =  "transparent";

      if(data.color.hasOwnProperty("bg")) {
        bgColor = data.color['bg'];
      }


      let initFontSize = cornerstoneTools.textStyle.getFontSize();

      data.fontSize =
        data.fontSize !== undefined
          ? data.fontSize
          : cornerstoneTools.textStyle.getFontSize();

      cornerstoneTools.textStyle.setFont(
        `${data.fontSize * viewport.scale}px Roboto`,
      );
      cornerstoneTools.textStyle.setFontSize(data.fontSize * viewport.scale);

      if (
        data.invalidated &&
        (data.who !== this.initialConfiguration.user ||
          data.when !== new Date().toLocaleString())
      ) {
        data.who = this.initialConfiguration.user;
        data.when = new Date().toLocaleString();
        if (
          this.initialConfiguration.momentLib &&
          this.initialConfiguration.defaultDateTimeFormat
        ) {
          data.whenStr = this.initialConfiguration
            .momentLib()
            .format(this.initialConfiguration.defaultDateTimeFormat);
        } else {
          data.whenStr = new Date().toLocaleString();
        }
      }

      draw(context, (context) => {
        setShadow(context, config);

        const options = {
          centering: {
            x: false,
            y: false,
          },
        };

        let textRows = [];
        let w = 40;
        const rotation = viewport.rotation;
        const initRot = data.initialRotation || 0;

        let deg =  (rotation - initRot) * (Math.PI/180);
        if(rotation === initRot) {
          deg = 0;
        }

        if((initRot === 0 || initRot === 180)) {
          if (Math.abs(data.handles.end.x - data.handles.start.x) > 40) {
            w = Math.abs(data.handles.end.x - data.handles.start.x) - 30 ;
          }
        } else {
          if (Math.abs(data.handles.end.y - data.handles.start.y) > 40) {
            w = Math.abs(data.handles.end.y - data.handles.start.y) - 30 ;
          }
        }

        w = Math.max(Math.abs(w), 40);

        context.font = `${data.fontSize }px Roboto`;

        if (data.text)
          textRows = Formatter.fragmentCanvasText(context, data.text, w);

        context.font = `${data.fontSize * viewport.scale}px Roboto`;

        const { element } = eventData;

        const handleOptions = {
          color: color.hasOwnProperty('main')? color['main']: color,
        };

        let h = {
          end: data.handles.end,
          start: data.handles.start,
        };

        const textCoordsStart =
          cornerstoneTools.external.cornerstone.pixelToCanvas(
            eventData.element,
            data.handles.start,
          );
        const textCoordsEnd =
          cornerstoneTools.external.cornerstone.pixelToCanvas(
            eventData.element,
            data.handles.end,
          );

        context.fillStyle = bgColor;
        context.fillRect(
          textCoordsStart.x,
          textCoordsStart.y,
          textCoordsEnd.x - textCoordsStart.x,
          textCoordsEnd.y - textCoordsStart.y,
        );

        context.save();
        context.translate(textCoordsStart.x, textCoordsStart.y);
        context.rotate(deg);

        context.fillStyle = data.color.hasOwnProperty('main')? data.color['main']:data.color;
        context.font = `${data.fontSize * viewport.scale}px Roboto`;

        textRows.forEach((textRow, index) => {
          context.fillText(textRow, 10, (data.fontSize * viewport.scale + (index * data.fontSize * viewport.scale)));
        });

        context.restore();

        if (data.active) {
          drawHandles(context, eventData, h, handleOptions);
        }


        const tooltipText = `${data.who} (${data.whenStr})`;

        if ((data.active || this.options.showUser) && data.who) {
          drawTextBox(
            context,
            tooltipText,
            textCoordsEnd.x,
            textCoordsEnd.y,
            "white",
            options,
          );
        }

        data.invalidated = false;
      });

      cornerstoneTools.textStyle.setFontSize(initFontSize);
      cornerstoneTools.textStyle.setFont(`${initFontSize}px Roboto`);
    }
  }

  changeTextCallback(data, eventData, doneChangingTextCallback) {
    const customDoneChangingTextCallback = () => {
      doneChangingTextCallback(
        data,
        document.getElementById("annotation-text").value,
      );

      document.getElementById("text-tool-modal").style.display = "none";

      document
        .getElementById("save-annotation")
        .removeEventListener("click", customDoneChangingTextCallback);
      document
        .getElementById("save-annotation")
        .removeEventListener("click", closeModal);
    };

    const closeModal = () => {
      document.getElementById("text-tool-modal").style.display = "none";

      document
        .getElementById("save-annotation")
        .removeEventListener("click", customDoneChangingTextCallback);
      document
        .getElementById("save-annotation")
        .removeEventListener("click", closeModal);
    };

    if (data.text !== "double click to edit text")
      document.getElementById("annotation-text").value = data.text;
    else document.getElementById("annotation-text").value = "";

    document.getElementById("text-tool-modal").style.display = "block";

    document
      .getElementById("save-annotation")
      .addEventListener("click", customDoneChangingTextCallback);
    document
      .getElementById("cancel-annotation")
      .addEventListener("click", closeModal);
  }

  _updateTextForNearbyAnnotation(evt) {
    const element = evt.detail.element;
    const coords = evt.detail.currentPoints.canvas;
    const toolState = cornerstoneTools.getToolState(element, this.name);

    if (!toolState) {
      return false;
    }

    for (let i = 0; i < toolState.data.length; i++) {
      const data = toolState.data[i];

      if (
        this.pointNearTool(element, data, coords) ||
        pointInsideBoundingBox(data.handles.textBox, coords)
      ) {
        data.active = true;
        window.cornerstone.updateImage(element);

        // Allow relabelling via a callback
        this.configuration.changeTextCallback(
          data,
          evt.detail,
          this.changeTextCallback.bind(this, element, data),
        );

        evt.stopImmediatePropagation();
        evt.preventDefault();
        evt.stopPropagation();

        return true;
      }
    }
  }
}
